var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.647 13.663C14.6178 13.5811 14.5831 13.5012 14.543 13.424L14.548 13.435C14.402 13.094 13.228 10.826 13.032 10.517L7.58104 -0.000976562L1.99104 10.775C1.80104 11.085 0.759045 13.095 0.615045 13.435L0.558045 13.561C0.186269 14.4671 -0.00334183 15.4376 4.45717e-05 16.417C4.45717e-05 18.4279 0.79886 20.3564 2.22076 21.7783C3.64266 23.2002 5.57117 23.999 7.58204 23.999C9.59292 23.999 11.5214 23.2002 12.9433 21.7783C14.3652 20.3564 15.164 18.4279 15.164 16.417V16.411L15.165 16.31C15.165 15.355 14.975 14.444 14.63 13.614L14.647 13.661V13.663ZM7.58504 22.018C6.61512 22.0182 5.66187 21.7658 4.81912 21.2857C3.97638 20.8056 3.2732 20.1142 2.77882 19.2798C2.28443 18.4453 2.01589 17.4965 1.99962 16.5267C1.98336 15.5569 2.21993 14.5996 2.68604 13.749L2.67104 13.778C2.5978 14.1674 2.56097 14.5628 2.56104 14.959V14.96C2.5621 16.7356 3.26791 18.4381 4.52343 19.6936C5.77894 20.9492 7.48148 21.655 9.25704 21.656C9.37004 21.656 9.49104 21.656 9.60304 21.65C8.96392 21.8956 8.28474 22.0204 7.60004 22.018H7.57704H7.57804H7.58504Z",
    fill: "url(#paint0_linear_377_4592)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_377_4592",
    x1: 7.58252,
    y1: -0.000976563,
    x2: 7.58252,
    y2: 23.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC371"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlood);
export default __webpack_public_path__ + "static/media/Blood.c0b2cf04d5a064ec072975ecbb165109.svg";
export { ForwardRef as ReactComponent };